export interface ColorOption {
  id: string;
  label: string;
  hex: string;
  /** Swatches that need a visible border because they're too close to the panel background */
  needsBorder?: boolean;
}

export const colorOptions: ColorOption[] = [
  { id: "schwarz", label: "Schwarz", hex: "#0a0a0a" },
  { id: "weiss", label: "Weiss", hex: "#ffffff", needsBorder: true },
  { id: "silber", label: "Silber", hex: "#9ca3af" },
  { id: "rot", label: "Rot", hex: "#dc2626" },
  { id: "orange", label: "Orange", hex: "#ea580c" },
  { id: "gold", label: "Gold", hex: "#c9971f" },
  { id: "gelb", label: "Gelb", hex: "#eab308" },
  { id: "gruen", label: "Grün", hex: "#16a34a" },
  { id: "blau", label: "Blau", hex: "#2563eb" },
  { id: "pink", label: "Pink", hex: "#db2777" },
];

export const defaultColorId = "schwarz";

export function getColorOption(id: string): ColorOption {
  return colorOptions.find((c) => c.id === id) ?? colorOptions[0];
}
